import "./alert.css";
import React from "react";
import { AlertContext } from "../context/alertContext";

export const Alert = () => {
  const {alert , hideAlert} = React.useContext(AlertContext);
  return (
    <div ref={alert} className="alertDiv">
      <div className="alert">
        <div>
          <div>
            <div>Gmail ID :-</div>
            <div>rahulkumar90270@gmail.com</div>
          </div>
          <div>
            <button onClick={hideAlert}>Done</button>
          </div>
        </div>
      </div>
    </div>
  );
};
